import React, { useState, useEffect } from "react";
import { doc, updateDoc, getFirestore } from "firebase/firestore";
import { app } from "../firbase/confing";
import { authUser } from "./Login";
const db = getFirestore(app);

async function updateDbDoc({ url, description, directors, actors, id, radio }) {
  const Movie = doc(db, authUser?.currentUser?.uid, id);
  await updateDoc(Movie, {
    url: url,
    description: description,
    directors: directors,
    actors: actors,
    type: radio,
  });
}
export default function Upload({ detail, changeDiv }) {
  const { description, directors, actors, id, url, type } = detail;
  const [state, setstate] = useState({
    url: url,
    description: description,
    directors: directors,
    actors: actors,
    id: id,
    radio: type,
  });
  useEffect(() => {
    document.getElementById(state.radio).checked = true;
  }, []);

  const [loading, setloading] = useState(false);

  const updateState = (e) => {
    const { name, value } = e.target;
    setstate({ ...state, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setloading(true);
    updateDbDoc(state).then(() => {
      setloading(false);
      changeDiv();
    });
  };
  return (
    <div className="row border-for-video mt-5">
      <div className="col-lg-6 col-md-10  p-2">
        <div className="parentIframe">
          <iframe
            src={state.url}
            className="iframe"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <div className="col-lg-6 upload-form col-md-10 p-3 video-text-show">
        <form onSubmit={handleSubmit} id="edit-db-form">
          <input
            type="text"
            name="url"
            value={state.url}
            onChange={updateState}
            placeholder="You Tube Url"
            title="Minimum 2 letter must"
            pattern=".{2,}"
            required
          />
          <br />
          <br />
          <input
            type="text"
            value={state.description}
            onChange={updateState}
            name="description"
            placeholder="Discription"
            title="Minimum 2 letter must"
            pattern=".{2,}"
            required
          />
          <br />
          <br />
          <input
            type="text"
            name="directors"
            value={state.directors}
            onChange={updateState}
            pattern=".{2,}"
            placeholder="Directors"
            title="Minimum 2 letter must"
            required
          />
          <br />
          <br />
          <input
            type="text"
            name="actors"
            value={state.actors}
            onChange={updateState}
            pattern=".{2,}"
            title="Minimum 2 letter must"
            placeholder="Actors"
            required
          />
          <br />
          <br />
          <div>
            <p>
              <input
                type="radio"
                name="radio"
                onChange={updateState}
                value="Movie"
                id="Movie"
                required
              />
              <label htmlFor="Movie">Movie</label>
            </p>
            <p className="mt-2">
              <input
                type="radio"
                name="radio"
                onChange={updateState}
                value="Teaser"
                id="Teaser"
                required
              />
              <label htmlFor="Teaser">Teaser</label>
            </p>
          </div>
          <br />
          <br />
          <div>
            <button type="submit">
              {loading ? (
                <>
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>{" "}
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>{" "}
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </>
              ) : (
                "UPDATE"
              )}
            </button>
            <button type="button" onClick={() => changeDiv()}>
              CANCEL
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
